// Valor total digitado à mão no plano "Somente pelo Tarifário", nas telas de rota (reserva e
// orçamento). São os mesmos estados do modal do Mapa (ver components/fields/ManualTotal.tsx): na
// criação o preço do tarifário aparece como badge com um lápis, e o campo só existe depois do
// clique. Um campo aberto e zerado tira o destaque do valor do tarifário, que é o certo em quase
// todo caso, e faz parecer que alguém tem de preencher.

// Desfazer do valor já travado ("voltar ao tarifário").
//
// O botão não pode contar com o par `name`/`value` que o navegador envia junto do submit: a tela
// de reserva e a de orçamento passam pelo `Form` (util/form.js), que intercepta o submit e chama
// o `submit()` nativo do DOM. Submit programático não carrega o par do botão clicado, então o
// pedido de desfazer sumiria no caminho e o valor manual voltaria a ser regravado.
//
// O clique acontece antes do submit, então preencher o campo escondido aqui é suficiente.
$(document).on("click", "[data-manual-total-clear]", function () {
  $(this).closest("form").find("[data-manual-total-field]").val("true");
});

var ManualTotal = {
  group: function (el) {
    return $(el).closest(".form-group");
  },

  // Centavos que a badge do tarifário está mostrando. Enquanto a consulta não responde ela mostra
  // um travessão, e aí não há valor a herdar.
  badgeCents: function (group) {
    var digits = group.find("[data-testid='rate-preview-amount'], #tariff-amount").text().replace(/\D/g, "");
    return digits ? parseInt(digits, 10) : 0;
  },

  setValue: function (input, cents) {
    // A máscara espera vírgula decimal; passar 1512.8 como número faria o campo virar 15.128,00.
    input.val((cents / 100).toFixed(2).replace(".", ","));
    if ($.fn.maskMoney) input.maskMoney("mask");
  }
};

// "Já puxando o valor atual como base": quem abre a edição está sobrepondo um preço que existe,
// não preenchendo um campo em branco.
$(document).on("click", "[data-manual-total-edit]", function () {
  var group = ManualTotal.group(this);
  var input = group.find("[data-manual-total-input]");

  input.data("manual-total-before-edit", input.val());
  ManualTotal.setValue(input, ManualTotal.badgeCents(group));
  group.find("[data-manual-total-preview]").addClass("d-none");
  group.find("[data-manual-total-editor]").removeClass("d-none");
  input.trigger("input").trigger("change").focus();
});

// Cancelar restaura o valor anterior; zerar uma reserva existente descartaria seu preço manual.
$(document).on("click", "[data-manual-total-cancel]", function () {
  var group = ManualTotal.group(this);
  var input = group.find("[data-manual-total-input]");

  input.val(input.data("manual-total-before-edit") || "0,00");
  if ($.fn.maskMoney) input.maskMoney("mask");
  group.find("[data-manual-total-editor]").addClass("d-none");
  group.find("[data-manual-total-preview]").removeClass("d-none");
  input.trigger("input").trigger("change");
});
